import React from "react";
import { useAuth0 } from "@auth0/auth0-react";

function LogoutButton({mobile}) {
  const { logout } = useAuth0();

  if (mobile) {
    return (
      <button className="material-icons" onClick={() => logout({ returnTo: window.location.origin })}>logout</button>
    );
  } else {
    return (
      <button onClick={() => logout({ returnTo: window.location.origin })}>
        Log Out
      </button>
    );
  }

}

export default LogoutButton;